var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightBigArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4065 4.06767C10.0975 3.75869 9.59653 3.75869 9.28756 4.06767C8.97858 4.37664 8.97858 4.87759 9.28756 5.18656L13.4752 9.37419H4.30876C3.8718 9.37419 3.51758 9.72841 3.51758 10.1654C3.51758 10.6023 3.8718 10.9565 4.30876 10.9565H13.4752L9.28756 15.1442C8.97858 15.4531 8.97858 15.9541 9.28756 16.2631C9.59653 16.572 10.0975 16.572 10.4065 16.2631L15.9447 10.7248C16.2537 10.4158 16.2537 9.91489 15.9447 9.60592L10.4065 4.06767Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBigArrow);
export default __webpack_public_path__ + "static/media/RightBigArrow.17514c6588a556c607221ec55a8a680d.svg";
export { ForwardRef as ReactComponent };